/*
 * Candidate Personal Info Tab Messages
 *
 * This contains all the text for the Candidate Personal Info Tab component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidatePersonalInfoTab';

export default defineMessages({
  basicWorkabilityTitle: {
    id: `${scope}.basicWorkabilityTitle`,
    defaultMessage: 'Basic Workability',
  },
  personalTitle: {
    id: `${scope}.personalTitle`,
    defaultMessage: 'Personal',
  },
  educationTitle: {
    id: `${scope}.educationTitle`,
    defaultMessage: 'Education',
  },
  activeMatriculationUntil: {
    id: `${scope}.activeMatriculationUntil`,
    defaultMessage: 'Active Matriculation until',
  },
  nextMatriculationFrom: {
    id: `${scope}.nextMatriculationFrom`,
    defaultMessage: 'Next Matriculation from',
  },
  workPermitValidUntil: {
    id: `${scope}.workPermitValidUntil`,
    defaultMessage: 'Work permit valid until',
  },
  workPermitValidFrom: {
    id: `${scope}.workPermitValidFrom`,
    defaultMessage: 'Work permit valid from',
  },
  dateOfBirth: {
    id: `${scope}.dateOfBirth`,
    defaultMessage: 'Date of Birth',
  },
  placeOfBirth: {
    id: `${scope}.placeOfBirth`,
    defaultMessage: 'Place of Birth',
  },
  countryOfBirth: {
    id: `${scope}.countryOfBirth`,
    defaultMessage: 'Country of Birth',
  },
  placeOfBirthPostalCode: {
    id: `${scope}.placeOfBirthPostalCode`,
    defaultMessage: 'Place of Birth Postal Code',
  },
  gender: {
    id: `${scope}.gender`,
    defaultMessage: 'Gender',
  },
  schoolUniversity: {
    id: `${scope}.schoolUniversity`,
    defaultMessage: 'School / University',
  },
  fieldOfStudy: {
    id: `${scope}.fieldOfStudy`,
    defaultMessage: 'Field of Study',
  },
  cityOfUniversityCountry: {
    id: `${scope}.cityOfUniversityCountry`,
    defaultMessage: 'City of University / Country',
  },
  highestSchoolDegree: {
    id: `${scope}.highestSchoolDegree`,
    defaultMessage: 'Highest School Degree',
  },
  highestLevelOfEducation: {
    id: `${scope}.highestLevelOfEducation`,
    defaultMessage: 'Highest Level of Education',
  },
});
